import { withStyles } from '@material-ui/core';
import Label from '../../common/Label';
import Value from '../../common/Value';

const styles = (theme) => ({
  container: {
    margin: '14 0'
  },
  value: {
    marginTop: 4,
    wordBreak: 'break-word',
    width: '90%',
    color: theme.dispatchPanelLabelValueColor,
    fontSize: theme.textFontSize,
    fontWeight: 500
  }
});
const Detail = ({ label, value, classes, upperCase = false }) => (
  <div className={classes.container}>
    <Label labelText={label} upperCase={upperCase} />
    <Value value={value ?? ''} customClasses={classes.value} />
  </div>
);

export default withStyles(styles)(Detail);
